import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo 登出
 */
const Logout = [
    'POST',
    RouteUrlList.API_Logout.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: 'OK',
        errorCode: '',
        data: {
            token: '34HafsdDt6235SFafsdf=='
        }
    }
];
export default Logout;
